import { useMemo } from "react"
import { getIntradayPeriodStaleness, IntradayPeriodStaleness } from "helpers/intraday"
import { getToday } from "helpers/types/dates"
import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { DEFAULT_CORE_STATE } from "../store/core-slice"
import { useDashboardModelName } from "./use-dashboard-model-name"

// No settle guard needed: staleness reads latestDate, which does not lag a period switch the
// way the per-period performance dates did.
export function useIntradayPeriodStaleness(): IntradayPeriodStaleness {
  const dashboardId = useDashboardId()
  const { period, endDate, latestDate, isIntraday } = useAppSelector(
    (s) => s.dashboard.core[dashboardId] ?? DEFAULT_CORE_STATE,
  )
  const modelName = useDashboardModelName()

  // isIntraday is capability (account/instrument supports intraday); the view is live only
  // when the dashboard's end date is actually today.
  const isIntradayMode = isIntraday && endDate === getToday()

  return useMemo(
    () => getIntradayPeriodStaleness(period, isIntradayMode, latestDate, modelName),
    [period, isIntradayMode, latestDate, modelName],
  )
}
